import React from 'react';
import { Route as ReactRoute, Switch, Redirect } from '@okapi/router-react';

import { routes, Route } from './routes';

const Router = () => <NestedRoutes routesTree={routes} />;

const NestedRoutes: React.FC<{ routesTree: Route[] | undefined }> = ({ routesTree = [] }) => (
	<Switch>
		{routesTree?.map(
			({ routes: nestedRoutes, component: Component, path, key, strict, exact }) => (
				<ReactRoute path={path} key={key} strict={strict} exact={exact}>
					{Component ? (
						<Component>
							<NestedRoutes routesTree={nestedRoutes} />
						</Component>
					) : (
						<NestedRoutes routesTree={nestedRoutes} />
					)}
				</ReactRoute>
			)
		)}
		<ReactRoute path="*">
			<Redirect to="/404" />
		</ReactRoute>
	</Switch>
);

export { routes, Router, NestedRoutes };
